import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Offcanvas, Nav } from 'react-bootstrap';
import { 
  FaDownload, 
  FaBookOpen, 
  FaArrowRight, 
  FaGraduationCap, 
  FaAtom, 
  FaDna, 
  FaFlask, 
  FaCalculator, 
  FaMountain, 
  FaChartLine, 
  FaLaptopCode,
  FaBrain,
  FaSearch,
  FaRocket,
  FaBookReader
} from 'react-icons/fa';

// Syllabus data structure for all exams and subjects
const syllabusData = {
  Physics: [
    { 
      examName: "IIT JEE", 
      title: "Physics for JEE Main & Advanced",
      description: "Complete syllabus for Physics covering mechanics, thermodynamics, electromagnetism, optics, and modern physics.",
      pdfUrl: "/syllabi/physics_jee.pdf",
      mockTestUrl: "/mock-tests/physics_jee",
      icon: <FaAtom className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
    },
    { 
      examName: "NEET", 
      title: "Physics for NEET UG",
      description: "Comprehensive physics syllabus for medical entrance covering required topics.",
      pdfUrl: "/syllabi/physics_neet.pdf",
      mockTestUrl: "/mock-tests/physics_neet",
      icon: <FaAtom className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
    },
    { 
      examName: "GATE", 
      title: "Physics for GATE",
      description: "Complete physics curriculum for GATE examination with all essential topics.",
      pdfUrl: "/syllabi/physics_gate.pdf",
      mockTestUrl: "/mock-tests/physics_gate",
      icon: <FaAtom className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Physics for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM requirements.",
      pdfUrl: "/syllabi/physics_jam.pdf",
      mockTestUrl: "/mock-tests/physics_jam",
      icon: <FaAtom className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Physics for CSIR NET",
      description: "Research-oriented physics syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/physics_csir.pdf",
      mockTestUrl: "/mock-tests/physics_csir",
      icon: <FaAtom className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
    },
    { 
      examName: "UPSC", 
      title: "Physics for UPSC",
      description: "Fundamental physics topics for UPSC general studies and optional paper.",
      pdfUrl: "/syllabi/physics_upsc.pdf",
      mockTestUrl: "/mock-tests/physics_upsc",
      icon: <FaAtom className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"
    }
  ],
  Chemistry: [
    { 
      examName: "IIT JEE", 
      title: "Chemistry for JEE Main & Advanced",
      description: "Complete syllabus covering physical, organic, and inorganic chemistry for JEE.",
      pdfUrl: "/syllabi/chemistry_jee.pdf",
      mockTestUrl: "/mock-tests/chemistry_jee",
      icon: <FaFlask className="text-success" size={24} />,
      color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
    },
    { 
      examName: "NEET", 
      title: "Chemistry for NEET UG",
      description: "Comprehensive chemistry syllabus for medical entrance examination.",
      pdfUrl: "/syllabi/chemistry_neet.pdf",
      mockTestUrl: "/mock-tests/chemistry_neet",
      icon: <FaFlask className="text-success" size={24} />,
      color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
    },
    { 
      examName: "GATE", 
      title: "Chemistry for GATE",
      description: "Advanced chemistry topics for GATE examination.",
      pdfUrl: "/syllabi/chemistry_gate.pdf",
      mockTestUrl: "/mock-tests/chemistry_gate",
      icon: <FaFlask className="text-success" size={24} />,
      color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Chemistry for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM chemistry requirements.",
      pdfUrl: "/syllabi/chemistry_jam.pdf",
      mockTestUrl: "/mock-tests/chemistry_jam",
      icon: <FaFlask className="text-success" size={24} />,
      color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Chemistry for CSIR NET",
      description: "Research-oriented chemistry syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/chemistry_csir.pdf",
      mockTestUrl: "/mock-tests/chemistry_csir",
      icon: <FaFlask className="text-success" size={24} />,
      color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
    },
    { 
      examName: "UPSC", 
      title: "Chemistry for UPSC",
      description: "Essential chemistry topics for UPSC general studies and optional paper.",
      pdfUrl: "/syllabi/chemistry_upsc.pdf",
      mockTestUrl: "/mock-tests/chemistry_upsc",
      icon: <FaFlask className="text-success" size={24} />,
      color: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
    }
  ],
  Mathematics: [
    { 
      examName: "IIT JEE", 
      title: "Mathematics for JEE Main & Advanced",
      description: "Complete syllabus for mathematics covering algebra, calculus, trigonometry, and coordinate geometry.",
      pdfUrl: "/syllabi/math_jee.pdf",
      mockTestUrl: "/mock-tests/math_jee",
      icon: <FaCalculator className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)"
    },
    { 
      examName: "GATE", 
      title: "Mathematics for GATE",
      description: "Advanced mathematics topics for GATE engineering examination.",
      pdfUrl: "/syllabi/math_gate.pdf",
      mockTestUrl: "/mock-tests/math_gate",
      icon: <FaCalculator className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Mathematics for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM mathematics requirements.",
      pdfUrl: "/syllabi/math_jam.pdf",
      mockTestUrl: "/mock-tests/math_jam",
      icon: <FaCalculator className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Mathematics for CSIR NET",
      description: "Research-oriented mathematics syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/math_csir.pdf",
      mockTestUrl: "/mock-tests/math_csir",
      icon: <FaCalculator className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)"
    },
    { 
      examName: "UPSC", 
      title: "Mathematics for UPSC",
      description: "Essential mathematics topics for UPSC optional paper.",
      pdfUrl: "/syllabi/math_upsc.pdf",
      mockTestUrl: "/mock-tests/math_upsc",
      icon: <FaCalculator className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)"
    }
  ],
  "Biotechnology": [
    { 
      examName: "NEET", 
      title: "Biotechnology for NEET UG/PG",
      description: "Comprehensive biotechnology syllabus for medical entrance examination.",
      pdfUrl: "/syllabi/biotech_neet.pdf",
      mockTestUrl: "/mock-tests/biotech_neet",
      icon: <FaDna className="text-info" size={24} />,
      color: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)"
    },
    { 
      examName: "GATE", 
      title: "Biotechnology for GATE",
      description: "Advanced biotechnology topics for GATE examination.",
      pdfUrl: "/syllabi/biotech_gate.pdf",
      mockTestUrl: "/mock-tests/biotech_gate",
      icon: <FaDna className="text-info" size={24} />,
      color: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Biotechnology for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM biotechnology requirements.",
      pdfUrl: "/syllabi/biotech_jam.pdf",
      mockTestUrl: "/mock-tests/biotech_jam",
      icon: <FaDna className="text-info" size={24} />,
      color: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Biotechnology for CSIR NET",
      description: "Research-oriented biotechnology syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/biotech_csir.pdf",
      mockTestUrl: "/mock-tests/biotech_csir",
      icon: <FaDna className="text-info" size={24} />,
      color: "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)"
    }
  ],
  "Geology & Geophysics": [
    { 
      examName: "GATE", 
      title: "Geology for GATE",
      description: "Advanced geology topics for GATE examination.",
      pdfUrl: "/syllabi/geology_gate.pdf",
      mockTestUrl: "/mock-tests/geology_gate",
      icon: <FaMountain className="text-warning" size={24} />,
      color: "linear-gradient(135deg, #f46b45 0%, #eea849 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Geology for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM geology requirements.",
      pdfUrl: "/syllabi/geology_jam.pdf",
      mockTestUrl: "/mock-tests/geology_jam",
      icon: <FaMountain className="text-warning" size={24} />,
      color: "linear-gradient(135deg, #f46b45 0%, #eea849 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Geology for CSIR NET",
      description: "Research-oriented geology syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/geology_csir.pdf",
      mockTestUrl: "/mock-tests/geology_csir",
      icon: <FaMountain className="text-warning" size={24} />,
      color: "linear-gradient(135deg, #f46b45 0%, #eea849 100%)"
    },
    { 
      examName: "UPSC", 
      title: "Geology for UPSC",
      description: "Essential geology topics for UPSC optional paper.",
      pdfUrl: "/syllabi/geology_upsc.pdf",
      mockTestUrl: "/mock-tests/geology_upsc",
      icon: <FaMountain className="text-warning" size={24} />,
      color: "linear-gradient(135deg, #f46b45 0%, #eea849 100%)"
    }
  ],
  "Mathematical Statistics": [
    { 
      examName: "IIT JAM", 
      title: "Statistics for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM statistics requirements.",
      pdfUrl: "/syllabi/stats_jam.pdf",
      mockTestUrl: "/mock-tests/stats_jam",
      icon: <FaChartLine className="text-secondary" size={24} />,
      color: "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)"
    },
    { 
      examName: "GATE", 
      title: "Statistics for GATE",
      description: "Advanced statistics topics for GATE examination.",
      pdfUrl: "/syllabi/stats_gate.pdf",
      mockTestUrl: "/mock-tests/stats_gate",
      icon: <FaChartLine className="text-secondary" size={24} />,
      color: "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Statistics for CSIR NET",
      description: "Research-oriented statistics syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/stats_csir.pdf",
      mockTestUrl: "/mock-tests/stats_csir",
      icon: <FaChartLine className="text-secondary" size={24} />,
      color: "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)"
    }
  ],
  "Computer Science": [
    { 
      examName: "GATE", 
      title: "Computer Science for GATE",
      description: "Comprehensive CS syllabus covering algorithms, data structures, OS, DBMS, and more.",
      pdfUrl: "/syllabi/cs_gate.pdf",
      mockTestUrl: "/mock-tests/cs_gate",
      icon: <FaLaptopCode className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #0061ff 0%, #60efff 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Computer Science for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM CS requirements.",
      pdfUrl: "/syllabi/cs_jam.pdf",
      mockTestUrl: "/mock-tests/cs_jam",
      icon: <FaLaptopCode className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #0061ff 0%, #60efff 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Computer Science for CSIR NET",
      description: "Research-oriented CS syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/cs_csir.pdf",
      mockTestUrl: "/mock-tests/cs_csir",
      icon: <FaLaptopCode className="text-primary" size={24} />,
      color: "linear-gradient(135deg, #0061ff 0%, #60efff 100%)"
    }
  ],
  "Electrical Engineering": [
    { 
      examName: "GATE", 
      title: "Electrical Engineering for GATE",
      description: "Comprehensive EE syllabus covering circuits, power systems, control systems, and more.",
      pdfUrl: "/syllabi/ee_gate.pdf",
      mockTestUrl: "/mock-tests/ee_gate",
      icon: <FaRocket className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #f83600 0%, #f9d423 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Electrical Engineering for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM EE requirements.",
      pdfUrl: "/syllabi/ee_jam.pdf",
      mockTestUrl: "/mock-tests/ee_jam",
      icon: <FaRocket className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #f83600 0%, #f9d423 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Electrical Engineering for CSIR NET",
      description: "Research-oriented EE syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/ee_csir.pdf",
      mockTestUrl: "/mock-tests/ee_csir",
      icon: <FaRocket className="text-danger" size={24} />,
      color: "linear-gradient(135deg, #f83600 0%, #f9d423 100%)"
    }
  ],
  "Mechanical Engineering": [
    { 
      examName: "GATE", 
      title: "Mechanical Engineering for GATE",
      description: "Comprehensive ME syllabus covering thermodynamics, manufacturing, fluid mechanics, and more.",
      pdfUrl: "/syllabi/me_gate.pdf",
      mockTestUrl: "/mock-tests/me_gate",
      icon: <FaBrain className="text-info" size={24} />,
      color: "linear-gradient(135deg, #5614b0 0%, #dbd65c 100%)"
    },
    { 
      examName: "IIT JAM", 
      title: "Mechanical Engineering for IIT JAM",
      description: "Detailed syllabus covering all IIT JAM ME requirements.",
      pdfUrl: "/syllabi/me_jam.pdf",
      mockTestUrl: "/mock-tests/me_jam",
      icon: <FaBrain className="text-info" size={24} />,
      color: "linear-gradient(135deg, #5614b0 0%, #dbd65c 100%)"
    },
    { 
      examName: "CSIR NET", 
      title: "Mechanical Engineering for CSIR NET",
      description: "Research-oriented ME syllabus for CSIR NET examination.",
      pdfUrl: "/syllabi/me_csir.pdf",
      mockTestUrl: "/mock-tests/me_csir",
      icon: <FaBrain className="text-info" size={24} />,
      color: "linear-gradient(135deg, #5614b0 0%, #dbd65c 100%)"
    }
  ]
};

// Main Component
const SyllabusCatalog = () => {
  const [activeKey, setActiveKey] = useState('Physics');
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const [searchTerm, setSearchTerm] = useState('');

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  // Toggle offcanvas for mobile and tablet
  const handleOffcanvasClose = () => setShowOffcanvas(false);
  const handleOffcanvasShow = () => setShowOffcanvas(true);

  // Get subject icon based on subject name
  const getSubjectIcon = (subject) => {
    switch(subject) {
      case 'Physics': return <FaAtom />;
      case 'Chemistry': return <FaFlask />;
      case 'Mathematics': return <FaCalculator />;
      case 'Biotechnology': return <FaDna />;
      case 'Geology & Geophysics': return <FaMountain />;
      case 'Mathematical Statistics': return <FaChartLine />;
      case 'Computer Science': return <FaLaptopCode />;
      case 'Electrical Engineering': return <FaRocket />;
      case 'Mechanical Engineering': return <FaBrain />;
      default: return <FaBookOpen />;
    }
  };

  // Get subject color based on subject name
  const getSubjectColor = (subject) => {
    switch(subject) {
      case 'Physics': return "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)";
      case 'Chemistry': return "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)";
      case 'Mathematics': return "linear-gradient(135deg, #ff0844 0%, #ffb199 100%)";
      case 'Biotechnology': return "linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)";
      case 'Geology & Geophysics': return "linear-gradient(135deg, #f46b45 0%, #eea849 100%)";
      case 'Mathematical Statistics': return "linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)";
      case 'Computer Science': return "linear-gradient(135deg, #0061ff 0%, #60efff 100%)";
      case 'Electrical Engineering': return "linear-gradient(135deg, #f83600 0%, #f9d423 100%)";
      case 'Mechanical Engineering': return "linear-gradient(135deg, #5614b0 0%, #dbd65c 100%)";
      default: return "linear-gradient(135deg, #333 0%, #666 100%)";
    }
  };

  // Render subject tabs
  const renderSubjectTabs = () => {
    const subjects = Object.keys(syllabusData);
    const filteredSubjects = subjects.filter(subject => 
      subject.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return (
      <>
        <div className="search-box mb-3 position-relative">
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <FaSearch className="text-muted" />
            </span>
            <input 
              type="text" 
              className="form-control border-start-0" 
              placeholder="Search subjects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <Nav variant="pills" className="flex-column subject-tabs">
          {filteredSubjects.map((subject) => (
            <Nav.Item key={subject}>
              <Nav.Link 
                active={activeKey === subject}
                onClick={() => {
                  setActiveKey(subject);
                  if (windowWidth < 992) {
                    handleOffcanvasClose();
                  }
                }}
                className="d-flex align-items-center py-3"
                style={{ 
                  background: activeKey === subject ? getSubjectColor(subject) : 'transparent'
                }}
              >
                <div className="subject-icon me-2">
                  {getSubjectIcon(subject)}
                </div>
                <span>{subject}</span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </>
    );
  };

  // Render syllabus cards
  const renderSyllabusCards = () => {
    const syllabi = syllabusData[activeKey] || [];
    
    return (
      <Row className="g-4">
        {syllabi.map((syllabus, index) => (
          <Col key={index} xs={12} sm={6} lg={4} xl={4}>
            <Card className="h-100 border-0 shadow syllabus-card">
              <div className="card-ribbon" style={{ background: syllabus.color || getSubjectColor(activeKey) }}></div>
              <Card.Body className="p-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="icon-circle" style={{ background: syllabus.color || getSubjectColor(activeKey) }}>
                    {syllabus.icon}
                  </div>
                  <div className="ms-3">
                    <div className="badge pill-badge" style={{ background: syllabus.color || getSubjectColor(activeKey) }}>
                      {syllabus.examName}
                    </div>
                  </div>
                </div>
                <Card.Title className="fs-5 fw-bold">{syllabus.title}</Card.Title>
                <Card.Text className="text-muted small mt-2">{syllabus.description}</Card.Text>
              </Card.Body>
              <Card.Footer className="bg-white border-0 p-4 pt-0">
                <div className="d-flex justify-content-between">
                  <Button 
                    variant="outline-primary" 
                    className="btn-download"
                    href={syllabus.pdfUrl}
                  >
                    <FaDownload className="me-2" /> Download
                  </Button>
                  <Button 
                    className="btn-mock-test"
                    style={{ 
                      background: syllabus.color || getSubjectColor(activeKey),
                      border: "none" 
                    }}
                    href={syllabus.mockTestUrl}
                  >
                    <FaBookOpen className="me-2" /> Practice
                  </Button>
                </div>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <div className="syllabus-catalog min-vh-100">
      <div className="banner text-center py-3 mb-5" style={{ background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)" }}>
        <Container>
          <div className="py-4">
            <h1 className="display-4 text-white fw-bold mb-2">Exam Syllabus Hub</h1>
            <p className="lead text-white opacity-90 mb-4">
              Find and download syllabi for various competitive exams like IIT JEE, NEET, GATE, JAM, CSIR NET, and UPSC
            </p>
            <div className="d-flex justify-content-center">
              <div className="pulse-animation">
                <FaGraduationCap size={60} className="text-white mb-3 ms-2 " /> <FaBookReader  size={50} className=" ms-2 text-white mb-3"/>
              </div>
            </div>
          </div>
        </Container>
      </div>
      
      <Container className="mb-5">
        {/* Mobile/Tablet View Toggle Button */}
        {windowWidth < 992 && (
          <div className="d-flex justify-content-start mb-4">
            <Button 
              variant="primary" 
              onClick={handleOffcanvasShow}
              className="d-flex align-items-center btn-browse"
            >
              Browse Subjects <FaArrowRight className="ms-2" />
            </Button>
          </div>
        )}
        
        <Row className="g-4">
          {/* Sidebar for Desktop */}
          {windowWidth >= 992 && (
            <Col lg={3} xl={3} className="mb-4 mb-lg-0">
              <div className="bg-white rounded-lg shadow-sm p-4 sidebar">
                <h4 className="mb-3 fw-bold">Browse Subjects</h4>
                {renderSubjectTabs()}
              </div>
            </Col>
          )}
          
          {/* Syllabus Content */}
          <Col lg={windowWidth >= 992 ? 9 : 12} xl={windowWidth >= 992 ? 9 : 12}>
            <div className="bg-white rounded-lg shadow-sm p-4 content-area">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h3 className="fw-bold mb-0">
                    <span 
                      className="subject-badge me-2"
                      style={{ background: getSubjectColor(activeKey) }}
                    >
                      {getSubjectIcon(activeKey)}
                    </span>
                    {activeKey} Syllabi
                  </h3>
                  <p className="text-muted small mt-1 mb-0">
                    {syllabusData[activeKey] ? syllabusData[activeKey].length : 0} examination syllabi available
                  </p>
                </div>
                {windowWidth < 992 && (
                  <Button 
                    variant="outline-primary"
                    onClick={handleOffcanvasShow}
                    className="btn-sm"
                  >
                    Change Subject
                  </Button>
                )}
              </div>
              {renderSyllabusCards()}
            </div>
          </Col>
        </Row>
        
        {/* Offcanvas for Mobile/Tablet */}
        <Offcanvas 
          show={showOffcanvas} 
          onHide={handleOffcanvasClose}
          placement="start"
          className="subject-offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="fw-bold">Browse Subjects</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {renderSubjectTabs()}
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    
      
      <style jsx global>{`
        .subject-tabs .nav-link {
          color: #495057;
          border-radius: 0.25rem;
          transition: all 0.3s;
        }
        
        .subject-tabs .nav-link.active {
          background-color: #0d6efd;
          color: white;
        }
        
        .subject-tabs .nav-link:hover:not(.active) {
          background-color: #f8f9fa;
        }
        
        .hover-effect {
          transition: transform 0.3s, box-shadow 0.3s;
        }
        
        .hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
        
        .subject-offcanvas {
          width: 280px;
        }
      `}</style>
    </div>
  );
};

export default SyllabusCatalog;